export function HomePage() {
  return (
    <>
      <section className="hero">
        <span className="badge">In development</span>
        <h1>Speak — don’t study the language as a map</h1>
        <p className="lead">
          UllSpeak is a voice language trainer. The goal is a working conversational base, not a
          complete atlas of the language.
        </p>
        <p className="coming">The iOS app is being built. This site is a temporary front door.</p>
      </section>
      <section className="grid">
        <article className="card">
          <h2>What it is</h2>
          <p>
            You speak. The partner listens and answers. Training follows speech patterns you
            actually use, so the next sentence comes without a pause and the mind stays on meaning,
            not form.
          </p>
        </article>
        <article className="card">
          <h2>What it is not</h2>
          <ul>
            <li>Not a course to “finish a language” or close a level</li>
            <li>Not a grammar textbook or a dictionary for every case</li>
            <li>Not a demo of how clever an AI can sound</li>
          </ul>
        </article>
        <article className="card">
          <h2>How it works</h2>
          <ul>
            <li>Sign in with Apple</li>
            <li>Live voice: microphone and a real-time conversation</li>
            <li>Meaning first: errors that break understanding matter most</li>
          </ul>
        </article>
        <article className="card">
          <h2>Now</h2>
          <p>
            Voice chat and sign-in already work. The training cycle on speech patterns is still
            being built. App Store release is next.
          </p>
          <p>
            Email: <a href="mailto:damir@rashidov.eu">damir@rashidov.eu</a>
          </p>
        </article>
      </section>
    </>
  );
}
